import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ Authorization: "Bearer " + localStorage.getItem("nexo_token") });

const MOIS = ["Jan","Fév","Mar","Avr","Mai","Jun","Jul","Aoû","Sep","Oct","Nov","Déc"];
const COLORS = ["#5b6ef8","#22d3a0","#f5a623","#a855f7","#ef4444","#14b8a6","#f97316","#06b6d4"];

const ACTION_LABELS = {
  creation: "✅ Création",
  changement_statut: "🔄 Changement statut",
  assignation: "👤 Assignation",
  reassignation: "🔀 Réassignation",
};
const STATUT_LABELS = {
  planifiee:"Planifié", en_cours:"En cours", terminee:"Terminé",
  annulee:"Annulé", brouillon:"Brouillon"
};

export default function Stats({ T }) {
  const [annee, setAnnee]       = useState(new Date().getFullYear());
  const [stats, setStats]       = useState({parMois:[],parTech:[],parTechMois:[],totaux:{total:0,terminees:0,annulees:0,taux_global:0}});
  const [historique, setHist]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [tab, setTab]           = useState("dashboard"); // dashboard | techniciens | historique
  const [filterTech, setFilter] = useState("all");

  const load = async () => {
    setLoading(true);
    try {
      const [s, h2] = await Promise.all([
        fetch(`${BASE}/stats?annee=${annee}`, {headers:h()}).then(r=>r.json()),
        fetch(`${BASE}/stats/historique?limit=100`, {headers:h()}).then(r=>r.json()),
      ]);
      if (s && !s.error) {
        setStats({
          parMois: Array.isArray(s.parMois) ? s.parMois : [],
          parTech: Array.isArray(s.parTech) ? s.parTech : [],
          parTechMois: Array.isArray(s.parTechMois) ? s.parTechMois : [],
          totaux: s.totaux || {total:0,terminees:0,annulees:0,taux_global:0},
          annee: s.annee || annee
        });
      } else { console.error("Stats error:", s); }
      setHist(Array.isArray(h2)?h2:[]);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  useEffect(()=>{ load(); },[annee]);

  const scoreColor = (taux) => {
    if (!taux) return T.muted;
    if (taux >= 80) return T.success;
    if (taux >= 50) return T.warning;
    return T.danger;
  };

  const maxVal = stats ? Math.max(...((stats.parMois||[]).map(m=>parseInt(m.total)||0)), 1) : 1;

  if (loading) return <div style={{textAlign:"center",padding:60,color:T.muted}}>⏳ Chargement...</div>;
  if (!stats) return null;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:22}}>

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontSize:25,fontWeight:800,color:T.text,letterSpacing:"-0.7px"}}>📊 Statistiques</div>
          <div style={{fontSize:13,color:T.muted,marginTop:4}}>Performance · Historique · Scores techniciens</div>
        </div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          {/* Sélection année */}
          <div style={{display:"flex",background:T.card,border:`1px solid ${T.border}`,borderRadius:9,overflow:"hidden"}}>
            <button onClick={()=>setAnnee(a=>a-1)} style={{padding:"8px 13px",background:"transparent",border:"none",color:T.muted,cursor:"pointer"}}>←</button>
            <div style={{padding:"8px 14px",fontSize:14,fontWeight:700,color:T.text,borderLeft:`1px solid ${T.border}`,borderRight:`1px solid ${T.border}`}}>{annee}</div>
            <button onClick={()=>setAnnee(a=>Math.min(a+1,new Date().getFullYear()))} style={{padding:"8px 13px",background:"transparent",border:"none",color:T.muted,cursor:"pointer"}}>→</button>
          </div>
          <button onClick={load} style={{padding:"8px 14px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:13,fontWeight:600,cursor:"pointer"}}>↻ Actualiser</button>
        </div>
      </div>

      {/* Onglets */}
      <div style={{display:"flex",background:T.card,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden",width:"fit-content"}}>
        {[["dashboard","📊 Vue globale"],["techniciens","👥 Techniciens"],["historique","📋 Historique"]].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)}
            style={{padding:"10px 18px",background:tab===k?T.accentDim:"transparent",border:"none",color:tab===k?T.accent:T.muted,fontSize:13,fontWeight:tab===k?700:500,cursor:"pointer"}}>
            {l}
          </button>
        ))}
      </div>

      {/* VUE GLOBALE */}
      {tab==="dashboard" && stats && (
        <div style={{display:"flex",flexDirection:"column",gap:18}}>
          {/* KPIs */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
            {[
              ["🔧","Total interventions", stats.totaux.total, T.accent],
              ["✅","Terminées",           stats.totaux.terminees, T.success],
              ["❌","Annulées",            stats.totaux.annulees, T.danger],
              ["🎯","Taux de complétion",  `${stats.totaux.taux_global||0}%`, scoreColor(parseFloat(stats.totaux.taux_global))],
            ].map(([ic,label,val,color])=>(
              <div key={label} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:"20px 22px"}}>
                <div style={{fontSize:24,marginBottom:8}}>{ic}</div>
                <div style={{fontSize:28,fontWeight:800,color,letterSpacing:"-1px"}}>{val}</div>
                <div style={{fontSize:12,color:T.muted,marginTop:4}}>{label} · {annee}</div>
              </div>
            ))}
          </div>

          {/* Graphique barres par mois */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:24}}>
            <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:20}}>Interventions par mois — {annee}</div>
            <div style={{display:"flex",alignItems:"flex-end",gap:8,height:180}}>
              {MOIS.map((m,idx)=>{
                const moisData = stats.parMois.find(r=>parseInt(r.mois)===idx+1);
                const total     = parseInt(moisData?.total||0);
                const terminees = parseInt(moisData?.terminees||0);
                const enCours   = parseInt(moisData?.en_cours||0);
                const planif    = parseInt(moisData?.planifiees||0);
                const h2 = total ? Math.round((total/maxVal)*160) : 0;
                const hT = total ? Math.round((terminees/maxVal)*160) : 0;
                const isCurrentMonth = idx+1===new Date().getMonth()+1 && annee===new Date().getFullYear();
                return(
                  <div key={m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                    <div style={{fontSize:10,color:T.muted,fontWeight:600,marginBottom:2}}>{total||""}</div>
                    <div style={{width:"100%",display:"flex",flexDirection:"column",justifyContent:"flex-end",height:160,position:"relative"}}>
                      {/* Barre totale */}
                      {h2>0&&<div style={{position:"absolute",bottom:0,left:"25%",width:"50%",height:h2,background:`${T.accent}30`,borderRadius:"4px 4px 0 0"}}/>}
                      {/* Barre terminées */}
                      {hT>0&&<div style={{position:"absolute",bottom:0,left:"25%",width:"50%",height:hT,background:T.success,borderRadius:"4px 4px 0 0",transition:"height 0.5s"}}/>}
                    </div>
                    <div style={{fontSize:10,color:isCurrentMonth?T.accent:T.muted,fontWeight:isCurrentMonth?700:400}}>{m}</div>
                  </div>
                );
              })}
            </div>
            <div style={{display:"flex",gap:16,marginTop:14,justifyContent:"center"}}>
              {[[T.success,"Terminées"],[`${T.accent}30`,"Total"]].map(([c,l])=>(
                <div key={l} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:T.muted}}>
                  <div style={{width:12,height:12,borderRadius:2,background:c}}/>
                  {l}
                </div>
              ))}
            </div>
          </div>

          {/* Top techniciens */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:24}}>
            <div style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:18}}>🏆 Classement techniciens — {annee}</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {(stats.parTech||[]).filter(t=>parseInt(t.total)>0).map((t,ti)=>{
                const taux = parseFloat(t.taux_completion)||0;
                const c = COLORS[ti%COLORS.length];
                return(
                  <div key={t.id} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",background:T.bg,borderRadius:11,border:`1px solid ${T.border}`}}>
                    <div style={{fontSize:18,fontWeight:800,color:T.muted,width:28,textAlign:"center"}}>{ti+1}</div>
                    <div style={{width:40,height:40,borderRadius:"50%",background:`${c}22`,border:`2px solid ${c}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:c,flexShrink:0}}>
                      {t.prenom[0]}{t.nom[0]}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:700,color:T.text}}>{t.prenom} {t.nom}</div>
                      <div style={{display:"flex",gap:12,marginTop:4,fontSize:11,color:T.muted}}>
                        <span>✅ {t.terminees} terminées</span>
                        <span>🔵 {t.en_cours} en cours</span>
                        <span>⏳ {t.planifiees} planifiées</span>
                        {parseInt(t.annulees)>0&&<span>❌ {t.annulees} annulées</span>}
                      </div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontSize:22,fontWeight:800,color:scoreColor(taux)}}>{taux}%</div>
                      <div style={{fontSize:10,color:T.muted,marginTop:2}}>taux complétion</div>
                    </div>
                    <div style={{width:80}}>
                      <div style={{height:6,background:T.border,borderRadius:3}}>
                        <div style={{height:"100%",borderRadius:3,background:scoreColor(taux),width:`${taux}%`,transition:"width 0.5s"}}/>
                      </div>
                    </div>
                  </div>
                );
              })}
              {(stats.parTech||[]).filter(t=>parseInt(t.total)>0).length===0&&(
                <div style={{textAlign:"center",padding:30,color:T.muted}}>Aucune donnée pour {annee}</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* VUE TECHNICIENS */}
      {tab==="techniciens" && stats && (
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          {(stats.parTech||[]).map((t,ti)=>{
            const c = COLORS[ti%COLORS.length];
            const taux = parseFloat(t.taux_completion)||0;
            const moisTech = (stats.parTechMois||[]).filter(m=>m.tech_id===t.id);
            const maxM = Math.max(...moisTech.map(m=>parseInt(m.total)||0), 1);
            return(
              <div key={t.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,overflow:"hidden"}}>
                {/* Header technicien */}
                <div style={{padding:"18px 22px",borderBottom:`1px solid ${T.border}`,background:`${c}0a`,display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:48,height:48,borderRadius:"50%",background:`${c}22`,border:`2.5px solid ${c}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:800,color:c}}>
                    {t.prenom[0]}{t.nom[0]}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:17,fontWeight:800,color:T.text}}>{t.prenom} {t.nom}</div>
                    <div style={{display:"flex",gap:14,marginTop:5,fontSize:12,color:T.muted,flexWrap:"wrap"}}>
                      <span>📊 {t.total} total</span>
                      <span>✅ {t.terminees} terminées</span>
                      <span>🔵 {t.en_cours} en cours</span>
                      <span>⏳ {t.planifiees} planifiées</span>
                      {parseInt(t.annulees)>0&&<span style={{color:T.danger}}>❌ {t.annulees} annulées</span>}
                    </div>
                  </div>
                  {/* Score */}
                  <div style={{textAlign:"center",background:T.card,borderRadius:12,padding:"12px 18px",border:`2px solid ${scoreColor(taux)}33`}}>
                    <div style={{fontSize:32,fontWeight:800,color:scoreColor(taux),letterSpacing:"-1px"}}>{taux}%</div>
                    <div style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px"}}>Complétion</div>
                    <div style={{marginTop:6,height:4,background:T.border,borderRadius:2}}>
                      <div style={{height:"100%",borderRadius:2,background:scoreColor(taux),width:`${taux}%`}}/>
                    </div>
                  </div>
                </div>

                {/* Graphique par mois */}
                <div style={{padding:"18px 22px"}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:14}}>Performance mensuelle {annee}</div>
                  <div style={{display:"flex",alignItems:"flex-end",gap:6,height:100}}>
                    {MOIS.map((m,idx)=>{
                      const md = moisTech.find(r=>parseInt(r.mois)===idx+1);
                      const total = parseInt(md?.total||0);
                      const term  = parseInt(md?.terminees||0);
                      const tauxM = parseFloat(md?.taux||0);
                      const hBar  = total ? Math.round((total/maxM)*80) : 0;
                      const hTerm = total ? Math.round((term/maxM)*80) : 0;
                      return(
                        <div key={m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                          {total>0&&<div style={{fontSize:9,color:T.muted,fontWeight:600}}>{tauxM}%</div>}
                          <div style={{width:"100%",height:80,display:"flex",flexDirection:"column",justifyContent:"flex-end",position:"relative"}}>
                            {hBar>0&&<div style={{position:"absolute",bottom:0,left:"20%",width:"60%",height:hBar,background:`${c}25`,borderRadius:"3px 3px 0 0"}}/>}
                            {hTerm>0&&<div style={{position:"absolute",bottom:0,left:"20%",width:"60%",height:hTerm,background:c,borderRadius:"3px 3px 0 0"}}/>}
                          </div>
                          <div style={{fontSize:9,color:T.muted}}>{m}</div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Grille scores par mois */}
                  <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:8,marginTop:14}}>
                    {MOIS.map((m,idx)=>{
                      const md = moisTech.find(r=>parseInt(r.mois)===idx+1);
                      const total = parseInt(md?.total||0);
                      const tM = parseFloat(md?.taux||0);
                      const isCurrentMonth = idx+1===new Date().getMonth()+1 && annee===new Date().getFullYear();
                      return(
                        <div key={m} style={{background:T.bg,borderRadius:8,padding:"8px",textAlign:"center",border:`1px solid ${isCurrentMonth?c:T.border}`,opacity:total?1:0.4}}>
                          <div style={{fontSize:10,color:T.muted,fontWeight:700,marginBottom:4}}>{m}</div>
                          {total>0?(
                            <>
                              <div style={{fontSize:15,fontWeight:800,color:scoreColor(tM)}}>{tM}%</div>
                              <div style={{fontSize:9,color:T.muted}}>{md?.terminees}/{total}</div>
                            </>
                          ):<div style={{fontSize:11,color:T.muted}}>—</div>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* HISTORIQUE */}
      {tab==="historique" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{fontSize:14,fontWeight:600,color:T.text}}>{historique.length} événements enregistrés</div>
            <div style={{marginLeft:"auto",display:"flex",gap:8}}>
              {["all","reassignation","changement_statut","creation"].map(f=>(
                <button key={f} onClick={()=>setFilter(f)}
                  style={{padding:"6px 13px",borderRadius:16,border:`1px solid ${filterTech===f?T.accent:T.border}`,background:filterTech===f?T.accentDim:"transparent",color:filterTech===f?T.accent:T.muted,fontSize:12,fontWeight:filterTech===f?700:500,cursor:"pointer"}}>
                  {f==="all"?"Tout":f==="reassignation"?"🔀 Réassign.":f==="changement_statut"?"🔄 Statuts":"✅ Créations"}
                </button>
              ))}
            </div>
          </div>

          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {historique
              .filter(h=>filterTech==="all"||h.action===filterTech)
              .map(h=>{
                const actionColor = h.action==="reassignation"?T.warning:h.action==="creation"?T.success:h.action==="assignation"?T.accent:T.mutedL;
                return(
                  <div key={h.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:11,padding:"14px 16px",display:"flex",gap:14,alignItems:"flex-start",borderLeft:`3px solid ${actionColor}`}}>
                    <div style={{fontSize:22,flexShrink:0}}>{h.action==="reassignation"?"🔀":h.action==="creation"?"✅":h.action==="assignation"?"👤":"🔄"}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:5,flexWrap:"wrap"}}>
                        <span style={{fontSize:12,fontWeight:700,color:actionColor,background:`${actionColor}20`,padding:"2px 9px",borderRadius:20}}>{ACTION_LABELS[h.action]||h.action}</span>
                        <span style={{fontSize:12,fontWeight:700,color:T.text}}>{h.intervention_titre||"—"}</span>
                        <span style={{fontSize:11,color:T.muted,fontFamily:"monospace"}}>{h.intervention_ref||""}</span>
                      </div>
                      <div style={{fontSize:12,color:T.muted,marginBottom:4}}>👤 Client : {h.client_nom||"—"}</div>
                      {h.action==="reassignation"&&(
                        <div style={{fontSize:12,background:T.warningDim,border:`1px solid ${T.warning}30`,borderRadius:7,padding:"6px 10px",marginBottom:4}}>
                          🔀 <strong style={{color:T.warning}}>{h.ancien_tech_nom||"Non assigné"}</strong> → <strong style={{color:T.success}}>{h.nouveau_tech_nom||"Non assigné"}</strong>
                        </div>
                      )}
                      {h.action==="changement_statut"&&h.ancien_statut&&(
                        <div style={{fontSize:12,color:T.muted}}>
                          {STATUT_LABELS[h.ancien_statut]||h.ancien_statut} → <strong style={{color:T.text}}>{STATUT_LABELS[h.nouveau_statut]||h.nouveau_statut}</strong>
                        </div>
                      )}
                      {h.action==="assignation"&&h.nouveau_tech_nom&&(
                        <div style={{fontSize:12,color:T.muted}}>Assigné à <strong style={{color:T.text}}>{h.nouveau_tech_nom}</strong></div>
                      )}
                      {h.commentaire&&<div style={{fontSize:11,color:T.muted,marginTop:4,fontStyle:"italic"}}>💬 {h.commentaire}</div>}
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontSize:11,color:T.muted}}>{new Date(h.created_at).toLocaleDateString("fr-FR")}</div>
                      <div style={{fontSize:10,color:T.muted}}>{new Date(h.created_at).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}</div>
                      {h.fait_par_nom&&<div style={{fontSize:10,color:T.mutedL,marginTop:3}}>par {h.fait_par_nom}</div>}
                    </div>
                  </div>
                );
            })}
            {historique.filter(h=>filterTech==="all"||h.action===filterTech).length===0&&(
              <div style={{textAlign:"center",padding:40,color:T.muted}}>Aucun événement enregistré</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
